import { render, staticRenderFns } from "./UsersDisplayView.vue?vue&type=template&id=0564fb43&"
import script from "./UsersDisplayView.vue?vue&type=script&lang=js&"
export * from "./UsersDisplayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports